import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMisc = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 41 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="M20.396 25a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
    />
    <path
      fill="#F8BADD"
      d="M9.396 23a3 3 0 1 0 0-6 3 3 0 0 0 0 6M31.396 23a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
    />
    <path
      fill="#00215B"
      d="M13.639 25.243A5.98 5.98 0 0 1 9.396 27a5.98 5.98 0 0 1-4.242-1.757A5.98 5.98 0 0 1 3.396 21a5.98 5.98 0 0 1 1.758-4.243A5.98 5.98 0 0 1 9.396 15v1a4.98 4.98 0 0 0-3.535 1.465A4.98 4.98 0 0 0 4.396 21a4.98 4.98 0 0 0 1.465 3.535A4.98 4.98 0 0 0 9.396 26a4.98 4.98 0 0 0 3.536-1.465zM27.396 15.172a4.14 4.14 0 0 1 2.9-1.172 4.14 4.14 0 0 1 2.9 1.172 3.94 3.94 0 0 1 1.2 2.828 3.94 3.94 0 0 1-1.2 2.828 4.14 4.14 0 0 1-2.9 1.172v-1a3.14 3.14 0 0 0 2.201-.887c.574-.56.9-1.311.9-2.113s-.326-1.553-.9-2.113A3.14 3.14 0 0 0 30.296 15a3.14 3.14 0 0 0-2.201.887z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMisc);

export default ForwardRef;
